'use strict';
module.exports = class UserCodeStore {
  constructor() {
    this._userCodeByUrl = {};
  }

  set(url, userCode) {
    this._userCodeByUrl[url] = userCode;
    return this;
  }

  get(url) {
    return this._userCodeByUrl[url];
  }

  startUserCode(configs, storage, sdk) {
    return configs.map(config => {
      const code = this._userCodeByUrl[config.url];
      if (!code) {
        throw new Error(`the script ${config.url} was not loaded using the "load_user_code" event`);
      }
      return code(storage, config.routerData, sdk);
    });
  }
};
